<div class="cursor-pointer">
  <p [ngStyle]="pNgStyle">{{ label }}</p>
  <div class="bottom-border" [ngStyle]="ngStyle"></div>
</div>
@if (usePopover) {
  <app-popover>
    <div slot="start" class="flex justify-end">
      <i class="fa-solid fa-chevron-down size-20" style="color: white"></i>
    </div>
    <ng-content slot="end" />
  </app-popover>
}
